import { render, staticRenderFns } from "./CheckPhone.vue?vue&type=template&id=34334bfe"
import script from "./CheckPhone.vue?vue&type=script&lang=js"
export * from "./CheckPhone.vue?vue&type=script&lang=js"
import style0 from "./CheckPhone.vue?vue&type=style&index=0&id=34334bfe&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports